import { render, staticRenderFns } from "./QurbanDetail.vue?vue&type=template&id=5f0c5bf8"
import script from "./QurbanDetail.vue?vue&type=script&lang=js"
export * from "./QurbanDetail.vue?vue&type=script&lang=js"
import style0 from "./QurbanDetail.vue?vue&type=style&index=0&id=5f0c5bf8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports